import { useIsMutating } from '@tanstack/react-query';
import FormWithProvider from 'components/forms/form/Form';
import FormFieldset from 'components/forms/form/FormFieldset';
import TextField from 'components/forms/textField/TextField';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import { CancellationPolicyValue } from 'models/CancellationPolicy';
import { Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';

export const cancellationPolicyModalId = 'cancellation-policy-modal';
export const CANCELLATION_POLICY_MAX_CHARACTERS = 10000;

const formSchema = () => ({
  // appliesTo: Yup.string().required(),
  // appliesToProperties: Yup.array()
  //   .of(
  //     Yup.object({
  //       label: Yup.string(),
  //       value: Yup.string(),
  //       isFixed: Yup.boolean().optional(),
  //     }),
  //   )
  //   .label('properties')
  //   .when('appliesTo', {
  //     is: PROPERTIES_SELECTION.ALL_PROPERTIES,
  //     then: (schema) => schema.optional().nullable(true),
  //     otherwise: (schema) => schema.min(1).required(),
  //   }),
  text: Yup.string().max(CANCELLATION_POLICY_MAX_CHARACTERS).required(),
});

export type CancellationPolicyFormSchemaType = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof formSchema>>
>;

// const filterPropertyBy = ({
//   businessType,
// }: {
//   businessType: PropertyBusinessType;
// }) =>
//   businessType !== PropertyBusinessType.HOTEL &&
//   businessType !== PropertyBusinessType.UNIT;

const CancellationPolicyModal = ({
  onSubmit,
  mutationKey,
  cancellationPolicyValue,
}: {
  onSubmit: (data: CancellationPolicyFormSchemaType) => void;
  mutationKey: string[];
  cancellationPolicyValue?: CancellationPolicyValue;
}) => {
  const { t } = useTranslation();
  const isMutating = useIsMutating({
    mutationKey,
  });

  const isEditing = !!cancellationPolicyValue;
  const isUpdating = isMutating > 0;

  return (
    <FormWithProvider
      schema={formSchema()}
      onSubmit={onSubmit}
      defaultValues={{
        // appliesTo: PROPERTIES_SELECTION.SELECTED_PROPERTIES,
        // appliesToProperties: [
        //   {
        //     label: property.name,
        //     value: property.uid,
        //     isFixed: true,
        //   },
        // ],
        text: cancellationPolicyValue?.text,
      }}
    >
      <Modal.Header>
        <Modal.Title>
          {isEditing
            ? t(
                'pageProperty.feesTaxesAndPolicies.cancellationPolicy.modal.editTitle',
              )
            : t(
                'pageProperty.feesTaxesAndPolicies.cancellationPolicy.modal.addTitle',
              )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormFieldset disabled={isUpdating}>
          <Row className="d-flex flex-column">
            <TextField
              name="text"
              label={t(
                'pageProperty.feesTaxesAndPolicies.cancellationPolicy.modal.text',
              )}
              componentClass="textarea"
              required
              colSmInput={8}
              colSmLabel={4}
              rows={6}
              maxCharacters={CANCELLATION_POLICY_MAX_CHARACTERS}
              maxLength={CANCELLATION_POLICY_MAX_CHARACTERS}
            />
            {/* <PropertyMultiSelectFilterField
              label={t(
                'pageProperty.feesTaxesAndPolicies.cancellationPolicy.modal.appliesTo',
              )}
              name="appliesTo"
              filterPropertyBy={filterPropertyBy}
              colSmInput={8}
              colSmLabel={4}
              filtersColXs={12}
            /> */}
          </Row>
        </FormFieldset>
      </Modal.Body>

      <Modal.Footer>
        <ModalFormCancelButton disabled={isUpdating} />
        <ModalFormSubmitButton disabled={isUpdating} />
      </Modal.Footer>
    </FormWithProvider>
  );
};

CancellationPolicyModal.defaultProps = {
  cancellationPolicyValue: undefined,
};

export default CancellationPolicyModal;
